/**
 * THIS FILE IS TEMPORARY DON'T ADD THINGS OR CHANGE IT
 */

import { useCallback } from 'react';

import {
  GetMeDocument,
  GetMeUkUsersDocument,
  useGetMeQuery,
  useGetMeUkUsersQuery,
  useUpdateMeMutation,
  useUpdateMeUkUsersMutation,
} from 'generated/rbi-graphql';
import { useFlag } from 'state/launchdarkly';
import { LaunchDarklyFlag } from 'utils/launchdarkly';

export const useQueriesUkUsersNonMigrated = (getMeVariables = {}): any => {
  const enableGetMeQueryForUkUsersNonMigrated = useFlag(
    LaunchDarklyFlag.ENABLE_GETME_QUERY_FOR_UK_USERS_NON_MIGRATED
  );

  const getMeUkUsersQuery = useGetMeUkUsersQuery({
    skip: !enableGetMeQueryForUkUsersNonMigrated,
    variables: getMeVariables,
    fetchPolicy: 'cache-and-network',
  });

  const getMeQuery = useGetMeQuery({
    skip: enableGetMeQueryForUkUsersNonMigrated,
    variables: getMeVariables,
    fetchPolicy: 'cache-and-network',
  });

  const getUpdateMeUkUsersMutation = useUpdateMeUkUsersMutation({
    refetchQueries: [{ query: GetMeUkUsersDocument, variables: getMeVariables }],
    awaitRefetchQueries: true,
  });

  const getUpdateMeMutation = useUpdateMeMutation({
    refetchQueries: [{ query: GetMeDocument, variables: getMeVariables }],
    awaitRefetchQueries: true,
  });

  const getUseGetMeQuery = useCallback(
    (): any => (enableGetMeQueryForUkUsersNonMigrated ? getMeUkUsersQuery : getMeQuery),
    [enableGetMeQueryForUkUsersNonMigrated, getMeQuery, getMeUkUsersQuery]
  );

  const getUseUpdateMeMutation = useCallback(
    (): any =>
      enableGetMeQueryForUkUsersNonMigrated ? getUpdateMeUkUsersMutation : getUpdateMeMutation,
    [enableGetMeQueryForUkUsersNonMigrated, getUpdateMeMutation, getUpdateMeUkUsersMutation]
  );

  return [getUseGetMeQuery, getUseUpdateMeMutation];
};
